import React from "react";

const ArrowDown: React.FC = () => (
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.99935 2.5L9.99935 17.5" stroke="black" strokeLinecap="round"/>
<path d="M5 12.5L10 17.5L15 12.5" stroke="black" strokeLinecap="round"/>
</svg>
);

export default ArrowDown;
